import multiguard from 'vue-router-multiguard';
import middleware from '@/router/middleware';

import Login from '@/views/auth/Login';
import External from '@/views/auth/External';
import Register from '@/views/auth/Register';
import Auth from '@/views/auth/Auth';
import ForgotPassword from '@/views/auth/ForgotPassword';
import SelectRole from '@/views/auth/SelectRole';
import AfterRegister from '@/views/thanks/AfterRegister';

import Email from '@/views/auth/quick/Email';
import Password from '@/views/auth/quick/Password';
import Payment from '@/views/auth/quick/Payment';
import Thanks from '@/views/auth/quick/Thanks';

export default [
  {
    path: '/auth',
    component: Auth,
    name: 'auth',
    children: [
      {
        path: 'login',
        component: Login,
        name: 'auth-login',
        meta: { title: 'Sign In' },
        beforeEnter: multiguard([ middleware.isUnlogged ]),
      },
      {
        path: 'register',
        component: Register,
        name: 'auth-register',
        meta: { title: 'Sign Up' },
        props: { role: false, },
        beforeEnter: multiguard([ middleware.isUnlogged ]),
      },
      {
        path: 'after-register',
        component: AfterRegister,
        name: 'auth-after-register',
        meta: { title: 'Sign Up' },
        // props: { role: false, }
        beforeEnter: multiguard([ middleware.isUnlogged ]),
      },
      {
        path: 'select-role',
        component: SelectRole,
        name: 'auth-select-role',
        meta: { title: 'Select Role' },
        beforeEnter: multiguard([ middleware.isUnlogged ]),
      },
      {
        path: 'forgot-password',
        component: ForgotPassword,
        name: 'auth-forgot-password',
        meta: { title: 'Forgot Password' },
        beforeEnter: multiguard([ middleware.isUnlogged ]),
      },
  
  
      {
        path: 'quick/:plan/reg',
        component: Email,
        name: 'quick-reg',
        meta: { title: 'Registration' },
      },
      {
        path: 'quick/:plan/payment',
        component: Payment,
        name: 'quick-payment',
        meta: { title: 'Plan payment' },
        beforeEnter: multiguard([ middleware.isLogged ]),
      },
      {
        path: 'quick/:plan/thanks',
        component: Thanks,
        name: 'quick-thanks',
        meta: { title: 'Thank you' },
        beforeEnter: multiguard([ middleware.isLogged ]),
      },
      {
        path: 'quick/password',
        component: Password,
        name: 'quick-password',
        meta: { title: 'Set your password' },
        beforeEnter: multiguard([ middleware.isLogged ]),
      },
      {
        path: ':provider/callback',
        component: {
          template: '<div class="auth-component"></div>'
        }
      },
    ]
  },

  {
    path: '/auth/token/:token',
    component: External,
    name: 'auth-external',
  },
];
